import { Injectable, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';


/**
 * 檢查裝置是否為行動裝置
 * #裝置 #mobile #device
 */
@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private breakpointObserver = inject(BreakpointObserver);

  /** 行動裝置 */
  isMobile: boolean = false;

  constructor() {
    this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }
}
